import Vue from 'vue'
import VueRouter from 'vue-router'
import { DEFAULT_AUTHENTICATED_PATH } from './defaultRoute'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/index.vue'),
    hidden: true
  },
  {
    path: '/scada/editor/:id?',
    name: 'ScadaEditor',
    component: () => import('@/views/Admin/ScadaEditor.vue'),
    hidden: true
  },
  {
    path: '/scada/preview/:id',
    name: 'ScadaPreview',
    component: () => import('@/views/Admin/ScadaPreview.vue'),
    hidden: true
  },
  {
    path: '/device-monitor/empty/:deviceId',
    name: 'DeviceMonitorEmpty',
    component: () => import('@/views/DeviceMonitor/Empty.vue'),
    hidden: true,
    meta: { title: '设备监控' }
  },
  {
    path: '/device-monitor/runtime/:id',
    name: 'DeviceMonitorRuntime',
    component: () => import('@/views/Admin/ScadaPreview.vue'),
    hidden: true,
    meta: { title: '设备监控运行态' }
  },
  {
    path: '/admin/data-summary',
    redirect: '/data-summary',
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/views/Layout/index.vue'),
    redirect: DEFAULT_AUTHENTICATED_PATH,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/Home/index.vue'),
        meta: { title: '首页', icon: 'dashboard' }
      },
      {
        path: 'user',
        component: () => import('@/views/UserCenter/index.vue'),
        redirect: '/user/security',
        children: [
          {
            path: 'security',
            name: 'SecuritySettings',
            component: () => import('@/views/UserCenter/Security.vue'),
            meta: { title: '安全设置' }
          },
          {
            path: 'profile',
            name: 'UserProfile',
            component: () => import('@/views/UserCenter/Profile.vue'),
            meta: { title: '基本资料' }
          },
          {
            path: 'system',
            name: 'SystemSettings',
            component: () => import('@/views/UserCenter/System.vue'),
            meta: { title: '系统设置' }
          },
          {
            path: 'logs',
            name: 'OperationLogs',
            component: () => import('@/views/UserCenter/Logs.vue'),
            meta: { title: '操作日志' }
          },
          {
            path: 'feedback',
            name: 'Feedback',
            component: () => import('@/views/UserCenter/Feedback.vue'),
            meta: { title: '意见反馈' }
          }
        ]
      },
      {
        path: 'message',
        component: () => import('@/views/MessageCenter/index.vue'),
        redirect: '/message/all',
        children: [
          {
            path: 'all',
            name: 'AllMessages',
            component: () => import('@/views/MessageCenter/AllMessages.vue'),
            meta: { title: '全部消息' }
          },
          {
            path: 'read',
            name: 'ReadMessages',
            component: () => import('@/views/MessageCenter/ReadMessages.vue'),
            meta: { title: '已读消息' }
          },
          {
            path: 'unread',
            name: 'UnreadMessages',
            component: () => import('@/views/MessageCenter/UnreadMessages.vue'),
            meta: { title: '未读消息' }
          }
        ]
      },
      {
        path: 'data-summary',
        name: 'DataSummary',
        component: () => import('@/views/DataSummary/index.vue'),
        meta: { title: '数字中控', breadcrumb: ['数据汇总', '数字中控'] }
      },
      {
        path: 'device-monitor',
        name: 'DeviceMonitor',
        component: () => import('@/views/DeviceMonitor/index.vue'),
        meta: { title: '设备监控', breadcrumb: ['设备监控'] }
      },
      {
        path: 'monitor-video',
        name: 'MonitorVideoWall',
        component: () => import('@/views/DeviceMonitor/VideoWall.vue'),
        meta: { title: '视频监控', breadcrumb: ['设备监控', '视频监控'] }
      },
      {
        path: 'company-cockpit',
        name: 'CompanyCockpit',
        component: () => import('@/views/CompanyCockpit/index.vue'),
        meta: { title: '公司驾驶舱', breadcrumb: ['数据汇总', '公司驾驶舱'] }
      },
      {
        path: 'admin',
        component: () => import('@/views/Admin/index.vue'),
        redirect: '/admin/device-list',
        children: [
          {
            path: 'device-list',
            name: 'DeviceList',
            component: () => import('@/views/Admin/DeviceList.vue'),
            meta: { title: '设备管理', breadcrumb: ['设备中心', '设备管理'] }
          },
          {
            path: 'device-detail',
            name: 'DeviceDetail',
            component: () => import('@/views/Admin/DeviceDetail.vue'),
            meta: { title: '设备详情', breadcrumb: ['设备中心', '设备管理', '设备详情'] }
          },
          {
            path: 'device-recycle',
            name: 'DeviceRecycle',
            component: () => import('@/views/Admin/DeviceRecycle.vue'),
            meta: { title: '设备回收站', breadcrumb: ['设备中心', '设备回收站'] }
          },
          {
            path: 'group-list',
            name: 'GroupList',
            component: () => import('@/views/Admin/GroupList.vue'),
            meta: { title: '分组管理', breadcrumb: ['设备中心', '分组管理'] }
          },
          {
            path: 'device-access/safety',
            name: 'SafetyDeviceAccess',
            component: () => import('@/views/Admin/ProdEqui.vue'),
            meta: { title: '安全生产设备接入', breadcrumb: ['设备接入', '安全生产设备接入'] }
          },
          {
            path: 'device-access/monitor',
            name: 'MonitorDeviceAccess',
            component: () => import('@/views/Admin/MonitorEqui.vue'),
            meta: { title: '监控设备接入', breadcrumb: ['设备接入', '监控设备接入'] }
          },
          {
            path: 'device-access/firefight',
            name: 'FirefightDeviceAccess',
            component: () => import('@/views/Admin/FirefightEqui.vue'),
            meta: { title: '消防设备接入', breadcrumb: ['设备接入', '消防设备接入'] }
          },
          {
            path: 'device-access/other',
            name: 'OtherDeviceAccess',
            component: () => import('@/views/Admin/OtherEqui.vue'),
            meta: { title: '其他设备接入', breadcrumb: ['设备接入', '其他设备接入'] }
          },
          {
            path: 'api-interface',
            name: 'ApiInterface',
            component: () => import('@/views/Admin/ApiInterface.vue'),
            meta: { title: 'API接口', breadcrumb: ['API接口'] }
          },
          {
            path: 'data-mining',
            name: 'DataMining',
            component: () => import('@/views/Admin/DataMining.vue'),
            meta: { title: '数据挖掘与应用', breadcrumb: ['数据挖掘与应用'] }
          },
          {
            path: 'alarm-push',
            name: 'AlarmPush',
            component: () => import('@/views/Admin/AlarmPush.vue'),
            meta: { title: '告警中心', breadcrumb: ['告警中心'] }
          },
          {
            path: 'gm-center',
            name: 'GMCenter',
            component: () => import('@/views/Admin/GMCenter.vue'),
            meta: { title: 'GM管理', breadcrumb: ['GM中心', 'GM管理'] }
          },
          {
            path: 'account-levels',
            name: 'AccountLevels',
            component: () => import('@/views/Admin/AccountLevels.vue'),
            meta: { title: '账号分级管理', breadcrumb: ['账号管理', '账号分级管理'] }
          },
          {
            path: 'module-auth',
            name: 'ModuleAuth',
            component: () => import('@/views/Admin/ModuleAuth.vue'),
            meta: { title: '模块授权管理', breadcrumb: ['账号管理', '模块授权管理'] }
          },
          {
            path: 'organizations',
            redirect: '/admin/group-list'
          }
        ]
      }
    ]
  },
  // 404 page must be placed at the end !!!
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 解码 JWT 获取 exp，过期则清除残留 token
function cleanExpiredToken () {
  const token = localStorage.getItem('token')
  if (!token) return
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      // token 已过期，清除所有登录态
      localStorage.removeItem('token')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('username')
      localStorage.removeItem('role')
      localStorage.removeItem('modules')
    }
  } catch (e) {
    // token 格式异常，也清除
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('username')
    localStorage.removeItem('role')
    localStorage.removeItem('modules')
  }
}

// 每次路由切换前先清理过期 token
cleanExpiredToken()

const whiteList = ['/login']
router.beforeEach((to, from, next) => {
  const hasToken = Boolean(localStorage.getItem('token'))
  if (hasToken && to.path === '/login') return next({ path: DEFAULT_AUTHENTICATED_PATH })
  if (!hasToken && !whiteList.includes(to.path)) return next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
  return next()
})

export default router
